import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../store";
import { fetchContactSettings } from "../store/slices/contactSlice";

export function useSupportEmail(): string {
  const dispatch = useAppDispatch();
  const email = useAppSelector((state) => state.contact.supportEmail);
  useEffect((): void => {
    void dispatch(fetchContactSettings());
  }, [dispatch]);
  return email;
}
